module.exports = __webpack_public_path__ + "static/media/epicChest__top--open.d3305e08.png";